import React, { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import DashboardHome from "./pages/DashboardHome";
import MyReffral from "./pages/MyReffral";
import Myteam from "./pages/Myteam";
import LevelIncome from "./pages/LevelIncome";
import SalaryIncome from "./pages/SalaryIncome";
import WithdrwalHis from "./pages/WithdrwalHis";
import Withdrwal from "./pages/Withdrwal";
import { useDispatch, useSelector } from "react-redux";
import {
  setRefAddress,
  setUserInfo,
  setWalletAddress,
} from "./Redux/WallatSlice";
import { useAccount } from "wagmi";
import StakeHistory from "./pages/StakeHistory";
import { getUserDataApi } from "./utils/apiHandlers";
import { logout } from "./utils/helperFunctions";
import AirdropHistory from "./pages/AirdropHistory";
import LandingPage from "./pages/LandingPage";
import Profile from "./pages/Profile";
import Support from "./pages/Support";

function AppRoutes() {
  const { isLoggedIn } = useSelector((state) => state.wallet);
  const { walletAddress, userinfo, jwt } = useSelector((state) => state.wallet);
  const { address } = useAccount();
  const dispatch = useDispatch();
  const params = useLocation();

  useEffect(() => {
    dispatch(setWalletAddress(address));
  }, [address]);

  useEffect(() => {
    if (jwt && userinfo?.user) {
      getUserDataApi(jwt, { address: walletAddress })
        .then(async (res) => {
          if (res?.status == 200) {
            dispatch(setUserInfo(res?.data));
          }
          if (res?.relogin) {
            logout(dispatch);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, [walletAddress, jwt]);

  useEffect(() => {
    const refAddrFromUrl = params?.search || "";
    const refddaddr = refAddrFromUrl
      ? refAddrFromUrl?.slice(params?.search?.indexOf("referral=") + 9)
      : "";
      // console.log(refddaddr, 'refaddr')
    if (refddaddr) {
      dispatch(setRefAddress(refddaddr));
    }
  }, [params]);

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            !isLoggedIn ? <LandingPage /> : <Navigate to={"/dashboard"} />
          }
        />
        <Route
          path="/login"
          element={!isLoggedIn ? <Login /> : <Navigate to={"/dashboard"} />}
        />

        <Route
          path="/register"
          element={!isLoggedIn ? <Register /> : <Navigate to={"/dashboard"} />}
        />

        <Route
          path="/dashboard"
          element={
            isLoggedIn ? (
              <Dashboard dashboardChildren={<DashboardHome />} />
            ) : (
              <Navigate to={"/login"} />
            )
          }
        />
        <Route
          path="dashboard/Profile"
          element={<Dashboard dashboardChildren={<Profile />}></Dashboard>}
        />
        <Route
          path="dashboard/MyReferrals"
          element={<Dashboard dashboardChildren={<MyReffral />}></Dashboard>}
        />
        <Route
          path="dashboard/MyTeam"
          element={<Dashboard dashboardChildren={<Myteam />}></Dashboard>}
        />

        <Route
          path="dashboard/LevelIncome"
          element={<Dashboard dashboardChildren={<LevelIncome />}></Dashboard>}
        />
        
        <Route
          path="dashboard/SalaryIncome"
          element={<Dashboard dashboardChildren={<SalaryIncome />}></Dashboard>}
        />

        <Route
          path="dashboard/StakeHistory"
          element={<Dashboard dashboardChildren={<StakeHistory />}></Dashboard>}
        />

        <Route
          path="dashboard/AirdropHistory"
          element={
            <Dashboard dashboardChildren={<AirdropHistory />}></Dashboard>
          }
        />
        <Route
          path="dashboard/Withdrawal"
          element={<Dashboard dashboardChildren={<Withdrwal />}></Dashboard>}
        />

        <Route
          path="dashboard/WithdrawalHistory"
          element={<Dashboard dashboardChildren={<WithdrwalHis />}></Dashboard>}
        />
        <Route
          path="dashboard/support"
          element={<Dashboard dashboardChildren={<Support />}></Dashboard>}
        />
      </Routes>
    </>
  );
}

export default AppRoutes;
